module.exports = __webpack_public_path__ + "assets/img/img219.22d00190.png";